module.exports = __webpack_public_path__ + "static/media/2022_S_CA_ChTradi_RTMax18_SuspAncienModel_HD_02.18b0bf6f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2022_S_CA_ChTradi_RTMax18_SuspAncienModel_HD_02.jpg
// module id = 1153
// module chunks = 0